"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _referral_purchase = require("@/api/goods_activity/referral_purchase");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ReferralPurchaseTable',
  // 菜品活动 - 推荐购列表
  components: {},
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      tableData: [],
      total: 0,
      listQuery: {
        keywords: '',
        page: 1,
        limit: 10
      }
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleEdit: function handleEdit(item) {
      this.$emit('editActivity', item.fnId);
    },
    addActivity: function addActivity() {
      this.$emit('addActivity');
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    reset: function reset() {
      this.listQuery.keywords = '';
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this = this;
      this.loading = true;
      (0, _referral_purchase.referralPurchasePage)(this.listQuery).then(function (res) {
        _this.tableData = res.records;
        _this.total = res.total;
        _this.loading = false;
      }, function () {
        _this.loading = false;
      });
    },
    /**
     * 切换活动状态
     */
    handleStatusChange: function handleStatusChange(row) {
      var _this2 = this;
      var statusText = row.markForEnable ? '启用' : '禁用';
      var loading = this.$loading({
        lock: true,
        text: "\u6B63\u5728".concat(statusText, "..."),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _referral_purchase.toggleReferralStatus)(row.referralId, row.markForEnable).then(function () {
        _this2.$message.success("".concat(statusText, "\u6210\u529F"));
        loading.close();
      }).catch(function () {
        // 失败时恢复原状态
        row.markForEnable = !row.markForEnable;
        loading.close();
      });
    }
  }
};